const ENUMS = {
    Locations: {
        "LONDON": 1,
        "PARIS": 2,
        "OTHER": 3,
    }
}

export default ENUMS;